module.exports = __webpack_public_path__ + "img/s22.f3e8b583.png";